import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imGroupAnalytics', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/analytics/group-analytics/group-analytics.html'),
        controller: 'GroupAnalyticsController',
        controllerAs: 'GroupAnalyticsCtrl',
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/group-analytics/group-analytics.component.ts